import FullPageCenterContainer from '@components/FullPageCenterContainer';
import { PageMeta } from '@components/page-meta';
import { Button, makeStyles, Typography } from '@material-ui/core';
import { RouteComponentProps } from '@reach/router';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(({ spacing }) => ({
  heading: {
    marginBottom: spacing(4),
  },
}));

const LogoutPage = (_props: RouteComponentProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <PageMeta title="Logout" />
      <FullPageCenterContainer>
        <Typography variant="h1" className={classes.heading}>
          {t('account.loggedOut')}
        </Typography>
        <Button color="primary" variant="contained" href="login">
          {t('account.loginPage')}
        </Button>
      </FullPageCenterContainer>
    </>
  );
};

export default LogoutPage;
